import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShopSheinUsComponent } from './shop-shein-us/shop-shein-us.component';
import { StoresMainComponent } from './stores-main/stores-main.component';
import { StoresRoutingModule } from './stores-routing.module';
import { ShopWalmartUsComponent } from './shop-walmart-us/shop-walmart-us.component';
import { ShopAmazonUsComponent } from './shop-amazon-us/shop-amazon-us.component';
import { ShopRockAutoComponent } from './shop-rockauto/shop-rockauto.component';
import { ShopMacysComponent } from './shop-macys/shop-macys.component';
import { ShopBathAndBodyComponent } from './shop-bath-and-body/shop-bath-and-body.component';
import { ShopCartersComponent } from './shop-carters/shop-carters.component';
import { ShopDicksSportingGoodsComponent } from './shop-sporting-goods/shop-sporting-goods.component';
import { ShopAmericanEagleComponent } from './shop-american-eagle/shop-american-eagle.component';
import { ShopPartGeeksComponent } from './shop-part-geeks/shop-part-geeks.component';
import { ShopCJPonyComponent } from './shop-cj-pony/shop-cj-pony.component';
import { ShopTargetComponent } from './shop-target/shop-target.component';
import { ShopJCPenneyComponent } from './shop-jc-penney/shop-jc-penney.component';
import { ShopNordStromComponent } from './shop-nordstrom/shop-nordstrom.component';
import { ShopSummitRacingsComponent } from './shop-summit-racings/shop-summit-racings.component';
import { ShopThreadUpComponent } from './shop-threadup/shop-threadup.component';
import { ShopNewEggComponent } from './shop-newegg/shop-newegg.component';
import { ShopCrateAndBarrelComponent } from './shop-crateandbarrel/shop-crateandbarrel.component';
import { ShopBodyBuildingComponent } from './shop-bodybuilding/shop-bodybuilding.component';
import { ShopNeimanMarcusComponent } from './shop-neiman-marcus/shop-neiman-marcus.component';
@NgModule({
  declarations: [
    StoresMainComponent,
    ShopSheinUsComponent,
    ShopWalmartUsComponent,
    ShopAmazonUsComponent,
    ShopRockAutoComponent,
    ShopMacysComponent,
    ShopBathAndBodyComponent,
    ShopCartersComponent,
    ShopDicksSportingGoodsComponent, 
    ShopAmericanEagleComponent,
    ShopPartGeeksComponent,
    ShopCJPonyComponent,
    ShopTargetComponent,
    ShopJCPenneyComponent,
    ShopNordStromComponent,
    ShopSummitRacingsComponent,
    ShopThreadUpComponent,
    ShopNewEggComponent,
    ShopCrateAndBarrelComponent,
    ShopBodyBuildingComponent,
    ShopNeimanMarcusComponent
  ],
  imports: [
    CommonModule,
    StoresRoutingModule
    
  ]
})
export class StoresModule { }
